import { render, staticRenderFns } from "./RegistroHuevosFecha.vue?vue&type=template&id=4a820ea9&scoped=true"
import script from "./RegistroHuevosFecha.vue?vue&type=script&lang=js"
export * from "./RegistroHuevosFecha.vue?vue&type=script&lang=js"
import style0 from "./RegistroHuevosFecha.vue?vue&type=style&index=0&id=4a820ea9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a820ea9",
  null
  
)

export default component.exports